export default "__VITE_ASSET__27a489a7__"